<template>
  <CContainer>
    <CRow>
      <router-view :account="this.account" @updateAccount="updateAccount()" />
    </CRow>
  </CContainer>
</template>

<script>
export default {
    name: 'MyAccountView',
    data () {
      return {
        account: {}
      }
    },
    methods: {
      updateAccount() {
        this.$portalapi.get('/myaccount/info').then(
          response => {
            this.account = response.data
            this.$log.onDebug(JSON.stringify(this.account))
          }
        )
      }
    },
    created: function() {
      this.$portalapi.get('/myaccount/info')
        .then(response => {
          this.account = response.data
          this.$log.onDebug(JSON.stringify(this.account))
          })

    }
}
</script>

<style>

</style>